import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'antd/dist/reset.css'; // 引入 Ant Design 样式
import './App.css';
import './i18n'; // 初始化i18n
import { ConfigProvider } from 'antd';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider theme={{
    token: {
      colorPrimary: '#00c4b4',
    },
  }}>
    <App />
  </ConfigProvider>
);